import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";
import {CURRENT_ODDS_MODULE} from "../current-odds-module.consts";
import {LocalStorageUtils} from "../../../../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS} from "../../../../../core/consts";

export class CurrentOddsModuleChangeOddsHandler extends ActionHandler {
  type = CURRENT_ODDS_MODULE.ACTION_TYPES.oddsChange;
  localStorageUtils: LocalStorageUtils;

  static injectables = [LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  async action(params) {
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.oddsType, params.oddsType);
    this.appStore.setSelectedOddsType(params.oddsType);
  }
}
